import { gql, useMutation } from '@apollo/client';

const mutation = gql`
  mutation CancelCampaignAlerts($campaignIds: [Long!]!) {
    cancelCampaignAlerts(campaignIds: $campaignIds) {
      campaignId
      alerts {
        id
      }
    }
  }
`;

export type UseCancelCampaignAlertsResponse = {
  cancelCampaignAlerts: { campaignId: number; alerts: [{ id: number }] };
};

export type UseCancelCampaignAlertsVariables = {
  campaignIds: number[];
};

export const useCancelCampaignAlertsMutation = () => {
  const [cancelCampaignAlerts, { loading }] = useMutation<
    UseCancelCampaignAlertsResponse,
    UseCancelCampaignAlertsVariables
  >(mutation, {
    notifyOnNetworkStatusChange: true,
  });

  return {
    cancelCampaignAlerts,
    isLoading: loading,
  };
};
